module.exports = __webpack_public_path__ + "static/media/Dolores Kitchen Bookcases (2).faf0d8ca.jpg";